/**
* Shown when the customer clicks "Importer" while photos are still coming in : import only the ones
* received so far, or keep waiting. "Importer" fires "import-photos-early" (the Main stops the
* reception and opens the editor) ; "Continuer l'attente" just closes.
*
* `wording` { title, text } comes from the import source, so the screen says what is still running.
*/
fx.ns("shared.popups", class ConfirmEarlyImport extends fx.components.Popup {

	constructor(model, count, wording)
	{
		super(model);

		this._count = count || 0;
		this._wording = wording || {};
		this.contentWidth = 520;

		// Sized for the longest wording, not the shortest : the sentence carries the photo count and
		// differs per import source, so it runs to three or four lines. At 340 the block was taller than
		// the room it had, which left centring nothing to distribute — it started at the top, hence the
		// clock against the lid, and spilled at the bottom, hence the cut last line. A short message now
		// simply sits in more air. Ignored on a phone, where fx gives the popup the whole screen.
		this.contentHeight = 400;

		this.BUTTONS = 136;   // the two stacked buttons and the gap under them
	}

	create()
	{
		super.create();

		// On a phone fx sizes the popup's container 100% x 100% and ignores contentHeight
		// (fx/components/mobile/Popup.js), so the free space above the buttons is the screen, not the
		// card. Pinning the icon and the labels at fixed tops left them clustered at the top of it.
		let mobile = fx.browser.isMobile || fx.browser.isTablet;
		let free = (mobile ? fx.dom.height(window) : this.contentHeight) - this.BUTTONS;

		// icon and labels together, stacked and centred by the SCSS. No fixed heights : a title that
		// wraps to two lines on a narrow screen pushes the text down instead of being cut off.
		this.content = new fx.components.Box("early-content");
		this.addChild(this.content, { top : 0, left : 0, width : "100%", height : free });

		this.content.addChild(new fx.components.Text({ text : '<svg width="34" height="34" viewBox="0 0 24 24" fill="none">' +
			'<circle cx="12" cy="12" r="9" stroke="#e08a3c" stroke-width="2.2"/>' +
			'<path d="M12 7v5l3 2" stroke="#e08a3c" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
			className : "early-icon center" }), { width : 66, height : 66 });

		this.content.addChild(new fx.components.Text({ text : this._wording.title || fx.text("Envoi pas encore terminé"), className : "title center" }), { width : "100%" });

		this.content.addChild(new fx.components.Text({ text : this._wording.text || fx.text("Vos photos arrivent encore depuis votre mobile. Importer seulement les $ photos déjà reçues ?", this._count), className : "text center" }), { width : "82%" });

		// waiting is the primary action : it keeps every photo, importing now drops the ones still on
		// their way. So it takes the filled button, and the top slot.
		this.cancelButton = new fx.components.Button({ label : fx.text("Continuer l'attente"), type : "filled" });
		this.addChild(this.cancelButton, { bottom : 86, left : "center", width : 280, height : 50 });

		this.okButton = new fx.components.Button({ label : fx.text("Importer $ photos", this._count) });
		this.addChild(this.okButton, { bottom : 26, left : "center", width : 280, height : 46 });
	}

	onReady()
	{
		super.onReady();

		this.on("click", this._onConfirm, this.okButton);
		this.on("click", this.close, this.cancelButton);
		this.on("ESCAPE", this.close, fx.keyboard);
	}

	_onConfirm()
	{
		this.data.event("import-photos-early");
		this.close();
	}
});
